import React from "react";
import PropTypes from "prop-types";
import { IconButton } from "@totalsoft/rocket-ui";
import { DropdownItemDiv, InLineDiv, TypographyWidth } from "./NotificationComponentsStyled"

function NotificationItemComponent({notification, onMarkAsRead, onDismiss, text}) {

  return (
    <DropdownItemDiv>
      <InLineDiv onClick={onMarkAsRead(notification)}>
        <TypographyWidth>{notification.isRead ? text : <b>{text}</b>}</TypographyWidth>
      </InLineDiv>
      <div style={{ float: "right" }}>
        <IconButton type="cancel" onClick={onDismiss(notification)} color="secondary" size="small"/>
      </div>
    </DropdownItemDiv>
  );
}

NotificationItemComponent.propTypes = {
  notification: PropTypes.object.isRequired,
  onMarkAsRead: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  text: PropTypes.string
};

export default NotificationItemComponent;
